import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import { colors } from '../components/Colors'
import PageEye from '../components/PageEye'
import imgiconlocalizacao from '../icons/icon-localizacao.svg'
import imgbebe from '../img/utisemi-intensiva-bebe.jpg'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimentoCentros from '../components/CentralAtendimentoUtiSemi'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
  .half-text {
    display: flex;
    justify-content: space-between;
    p {
      width: 58%;
      margin-right: 30px;
      order: 1;
      @media ${device.mobileL} {
        width: 100%;
        order: 2;
      }
    }
    img {
      width: 40%;
      height: 80%;
      margin-top: -305px;
      order: 2;
      @media ${device.mobileL} {
        width: 100%;
        margin-top: 0px;
        margin-bottom: 0em;
        order: 1;
      }
    }
    :nth-of-type(3) {
      img {
        margin-top: 0px;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  .estrutura {
    display: flex;
    padding-top: 2em;
    div {
      width: 60%;
      padding-right: 75px;
      :nth-child(2) {
        padding-right: 0;
        padding-left: 50px;
        @media ${device.mobileL} {
          padding-left: 0px;
          order: 1;
        }
      }
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
      p {
        margin: 20px 0;
      }
    }
    img {
      width: 35%;
      padding-top: 1em;
      @media ${device.mobileL} {
        order: 2;
        width: 100%;
      }
    }
    a {
      color: #539e9f;
      text-decoration: none;
    }
    :nth-of-type(1) {
      img {
        padding-bottom: 1em;
      }
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
      padding-top: 0em;
    }
  }
  .accordion__panel {
    div {
      padding: 2em;
      p {
        color: #707070;
      }
    }
    section {
      padding: 30px;
      p {
        color: #707070;
        padding: 0px;
      }
    }
  }
  .quadro {
    background-color: #ffffff;
    color: ${colors.cinza};
    padding: 2em;
    overflow: hidden;
    box-shadow: 0px 34px 49px -53px rgba(0, 0, 0, 0.75);
    margin-bottom: 30px;
    h3 {
      color: ${colors.lilas};
      position: relative;
      margin: 0;
      font-size: 1em;
      padding: 2em 0;
      :before {
        position: absolute;
        content: '';
        top: 24px;
        left: 0;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 0px;
        }
      }
      :after {
        position: absolute;
        content: '';
        bottom: 24px;
        left: 0;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 0px;
        }
      }
      @media ${device.mobileL} {
        padding: 2em 5px 2em 0em;
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      padding-right: 50px;
      box-sizing: border-box;
      width: 75%;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0;
      }
    }
    img {
      max-width: 361px;
      padding: 0;
      width: 48%;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
        margin-top: 20px;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  :nth-of-type(2) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
  }
  :nth-of-type(3) {
    .inner {
      div {
        width: 52%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        max-width: 530px;
        width: 48%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
  }
  :nth-of-type(5) {
    padding-top: 0;
  }
  :nth-of-type(6) {
    background: ${colors.verdeGradienteReverso};
    h2 {
      color: #fff8d1;
    }
    color: #ffffff;
  }
  :nth-of-type(7) {
    h2 {
      color: #fa7373;
    }
  }
  :nth-of-type(8) {
    background: ${colors.lilasGradiente};
    h2 {
      margin-bottom: 0;
      color: #fff8d1;
    }
    color: #ffffff;
  }
  :nth-of-type(9) {
    h2 {
      color: #fa7373;
    }
  }
  :nth-of-type(10) {
    background: #fa7373;
    h2 {
      color: #fa7373;
    }
    color: #ffffff;
  }
  :nth-of-type(12) {
    background: ${colors.verdeGradiente};
    h2 {
      color: #fff8d1;
    }
    color: #ffffff;
  }
  :nth-of-type(13) {
    h2 {
      color: #fa7373;
    }
    .inner {
      .quadro {
        width: 49%;
        min-height: 298px;
        h3 {
          padding-top: 1em;
          padding-bottom: 2.5em;
          :before {
            top: 4px;
          }
          :after {
            bottom: 30px;
          }
        }
        @media ${device.mobileL} {
          padding-right: 2em;
          width: 100%;
          h3 {
            padding-left: 0;
            :before {
              left: 0px;
            }
            :after {
              left: 0px;
            }
          }
        }
      }
      :nth-of-type(2) {
        justify-content: flex-start;
        img {
          padding-right: 10px;
          max-width: 36px;
        }
      }
    }
  }
`

export const UtiSemiIntensivaTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Estrutura',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          titleWidth="430px"
          height="200px"
          right="0"
          bottom="0"
          imgWidth="45.2%"
          overflow="visible"
          imgInner
          mobileTop="-12%"
        />
        <GroupContent>
          <div className="center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>{parse(sessoes[1].texto)}</div>
            {sessoes[1].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[1].imagemDaSessao.localFile.childImageSharp.fluid
                }
              />
            ) : (
              <img
                src={sessoes[1].imagemDaSessao.sourceUrl}
                alt="Uti Semi Intensiva"
              />
            )}
          </div>
        </GroupContent>
        <PageEye
          title={sessoes[2].tituloDaSessao}
          content={sessoes[2].texto}
          image={sessoes[2].imagemDaSessao.sourceUrl}
          color="lilas-vermelho"
          height="274px"
          overflow="visible"
          titleWidth="525px"
          imgWidth="50%"
          right="-50px"
        />
        <GroupContent>
          <div className="center">{parse(sessoes[3].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[4].tituloDaSessao)}</h2>
              {parse(sessoes[4].texto)}
            </div>
            {sessoes[4].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[4].imagemDaSessao.localFile.childImageSharp.fluid
                }
              />
            ) : (
              <img
                src={sessoes[4].imagemDaSessao.sourceUrl}
                alt="Uti Semi Intensiva"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              {sessoes[5].acordeao.map((item, index) => (
                <AccordionItem key={index}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <h3>{parse(item.titulo)}</h3>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="estrutura ">{parse(item.conteudo)}</div>
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[6].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[6].texto)}</div>
              {sessoes[6].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[6].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                />
              ) : (
                <img
                  src={sessoes[6].imagemDaSessao.sourceUrl}
                  alt="Uti Semi Intensiva"
                />
              )}
            </div>
            <div className="estrutura">
              {sessoes[7].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[7].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                />
              ) : (
                <img
                  src={sessoes[7].imagemDaSessao.sourceUrl}
                  alt="Uti Semi Intensiva"
                />
              )}
              <div>{parse(sessoes[7].texto)}</div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[8].tituloDaSessao)}</h2>
          </div>
          <div className="center half-text">
            <div>{parse(sessoes[8].texto)}</div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center half-text">
            <img src={imgbebe} alt="Controle" />
            {parse(sessoes[9].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">{parse(sessoes[10].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[11].tituloDaSessao)}</h2>
            {parse(sessoes[11].texto)}
            <div className="quadro">
              <h3>{parse(sessoes[12].tituloDaSessao)}</h3>
              {parse(sessoes[12].texto)}
            </div>
            <div className="quadro">
              <h3>{parse(sessoes[13].tituloDaSessao)}</h3>
              {parse(sessoes[13].texto)}
            </div>
            {parse(sessoes[14].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[15].tituloDaSessao)}</h2>
            <div className="inner">
              <div className="quadro">
                <h3>{parse(sessoes[16].tituloDaSessao)}</h3>
                {parse(sessoes[16].texto)}
              </div>
              <div className="quadro">
                <h3>{parse(sessoes[17].tituloDaSessao)}</h3>
                {parse(sessoes[17].texto)}
              </div>
            </div>
            <div className="inner">
              <img src={imgiconlocalizacao} alt="Controle" />
              {parse(sessoes[18].texto)}
            </div>
          </div>
        </GroupContent>
        <CentralAtendimentoCentros
          title="Entre em contato pela nossa central"
          central="Central de atendimento"
        />
      </Container>
    </>
  )
}

UtiSemiIntensivaTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const UtiSemiIntensiva = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <UtiSemiIntensivaTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

UtiSemiIntensiva.propTypes = {
  data: PropTypes.object.isRequired,
}

export default UtiSemiIntensiva

export const UtiSemiIntensivaQuery = graphql`
  query UtiSemiIntensivaById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          acordeao {
            titulo
            conteudo
          }
          linksExternos {
            descricao
            titulo
            url
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
